import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { CommonService, WorkOrderService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./woprint.html",
})
export class workorderprint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  p1_total: any;
  p2_total: any;
  p3_total: any;
  tot_pcs: any;
  p1_val: any;
  p2_val: any;
  shadeList: any = [];
  p3_val: any;
  p1_name: any;
  p2_name: any;
  trimsList: any = [];
  p3_name: any;
  stitchingList: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  des_total: any;
  printdata: any = {};
  iornpresentList: any = [];
  iornList: any = [];
  presentList: any = [];
  wodata: any = {};
  collorData: any = {};
  deslist: any = {};
  wo_id: any;
  data: any;
  curshade: any;
  data1: any;
  width: any;
  cuffList: any = {};
  mLabelList: any = {};
  placketList: any = {};
  totalList: any = [];
  designList1: any = [];
  designList2: any = [];
  datalist: any = [];
  matching_data: any = [];
  match_data: any = {};
  buttonList: any = [];
  kajalist: any = [];
  collarList: any = [];

  @Input() set desData(val) {
    this.deslist = val;
    this.width = this.deslist.width;
    let param = {
      wo_id: this.deslist.wo_id,
      width: this.deslist.width,
      tot_pcs: this.deslist.tot_pcs,
    };

    //     this.getTrims(param);
    this.getDesignList(param);
    this.getMatchList(param);
    this.getStitchList(param);
    this.getIornPresentList(this.deslist);
    this.fshade(param);
  }
  isLoading: boolean = false;
  @ViewChild("printForm") printForm;
  constructor(
    public store: Store<fromRootStore.State>,
    private woservice: WorkOrderService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
    private commonservice: CommonService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(params) {
    this.woservice.getDesignList(params).then((res: any) => {
      this.designList1 = res.data;

      this.getTotal();
    });
  }
  getkajaList(param) {
    let data = param;
    for (var i = 0; i < data.length; i++) {
      let data1 = data[i];
      let obj: any = {};
      obj.shade = data1.shade;
      obj.ktot_pcs = (((data1.ftot + data1.htot) * 7.8) / 180).toFixed(1);
      obj.btot_pcs = (((data1.ftot + data1.htot) * 3.85) / 180).toFixed(1);
      this.kajalist.push(obj);
    }
  }
  getcollarList(data) {
    let data1 = data;
    let common = this.commonservice.itemMaster();
    let collar = data1.collar_no;
    let style = data1.style;

    let collarlist = common.data["collar_no_" + style + "_" + collar];
    for (var i = 0; i < collarlist.length; i++) {
      let obj: any = {};
      obj.collar = collarlist[i];
      obj.collar_no = this.wodata.collar_no;
      obj.fh36_tot = this.deslist.fh36_tot;
      obj.fh38_tot = this.deslist.fh38_tot;
      obj.fh40_tot = this.deslist.fh40_tot;
      obj.fh42_tot = this.deslist.fh42_tot;
      obj.fh44_tot = this.deslist.fh44_tot;
      obj.fh46_tot = this.deslist.fh46_tot;
      obj.tot_pcs = this.deslist.tot_pcs;

      this.collarList.push(obj);
    }
  }
  getStitchList(params) {
    this.woservice.getStitchList(params).then((res: any) => {
      let stitch = res.data;
      this.wodata.bone = stitch[0].bone;
      this.wodata.style = stitch[0].style;
      this.wodata.but_placket = stitch[0].but_placket;
      this.wodata.placket = stitch[0].placket;
      this.wodata.collar_no = stitch[0].collar_no;
      this.wodata.cuff_no = stitch[0].cuff_no;
      this.wodata.main_label = stitch[0].main_label;
      this.wodata.extra_label = stitch[0].extra_label;
      this.wodata.washcare = stitch[0].washcare;
      this.wodata.wo_date = stitch[0].wo_date;
      this.wodata.wo_no = stitch[0].wo_no;
      for (var i = 0; i < stitch.length; i++) {
        this.calcTotal(res.data);
      }
      this.getcuffList();
      this.getmLabel();
      this.getPlacket();
      this.getcollarList(this.wodata);
    });
  }
  getcuffList() {
    this.cuffList.cuff_no = this.wodata.cuff_no;
    this.cuffList.f36_tot = this.wodata.f36_tot * 2;
    this.cuffList.f38_tot = this.wodata.f38_tot * 2;
    this.cuffList.f40_tot = this.wodata.f40_tot * 2;
    this.cuffList.f42_tot = this.wodata.f42_tot * 2;
    this.cuffList.f44_tot = this.wodata.f44_tot * 2;
    this.cuffList.f46_tot = this.wodata.f46_tot * 2;
    this.cuffList.tot_pcs = this.wodata.tot_pcs * 2;
  }
  getmLabel() {
    this.mLabelList.main_label = this.wodata.main_label;
    this.mLabelList.extra_label = this.wodata.extra_label;
    this.mLabelList.fh36_tot = this.deslist.fh36_tot + 2;
    this.mLabelList.fh38_tot = this.deslist.fh38_tot + 2;
    this.mLabelList.fh40_tot = this.deslist.fh40_tot + 2;
    this.mLabelList.fh42_tot = this.deslist.fh42_tot + 2;
    this.mLabelList.fh44_tot = this.deslist.fh44_tot + 2;
    this.mLabelList.fh46_tot = this.deslist.fh46_tot + 2;
    this.mLabelList.fh36_tot = this.deslist.fh36_tot + 2;
    this.mLabelList.tot_pcs = this.deslist.tot_pcs + 12;
  }
  getPlacket() {
    this.placketList.placket = this.wodata.placket;
    this.placketList.but_placket = Math.round(
      (this.deslist.tot_pcs * 0.83) / 100 + 0.99
    );
    this.placketList.pltot_pcs = Math.round(
      (this.deslist.tot_pcs * 0.83) / 100 + 0.99
    );
    this.placketList.washcare = this.wodata.washcare;
    this.placketList.tot_pcs = this.deslist.tot_pcs;

    this.placketList.bone = this.wodata.bone;
    this.placketList.bone_tot_pcs = this.deslist.tot_pcs * 2;
  }
  getIornPresentList(data) {
    let params = {
      sample_no: data.sample_no,
    };
    this.woservice.getIornPresentList(params).then((res: any) => {
      let iornpresentList = res.data;
      for (var i = 0; i < iornpresentList.length; i++) {
        let data = iornpresentList[i];
        if (data.type == "Ironing") {
          data.tot_pcs = this.deslist.tot_pcs;
          if (data.particulars == "SIDE CLIP") {
            data.tot_pcs = this.deslist.tot_pcs * 2;
          }
          this.iornList.push(data);
        } else {
          data.tot_pcs = this.deslist.tot_pcs;
          if (data.particulars == "EXPOSE BELT") {
            data.tot_pcs = this.deslist.tot_pcs / 2;
          }
          this.presentList.push(data);
        }
      }
    });
  }
  fshade(params) {
    this.woservice.getShadeList(params).then((res: any) => {
      /*   res.data = res.data.concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data);  */
      // this.shadeList = res.data;
      for (var k = 0; k < res.data.length; k++) {
        let temp = res.data[k];
        let obj: any = {};
        obj.shade = temp.shade;
        let tot = Math.round((temp.ftot + temp.htot) / 2);
        obj.tot = tot;
        this.shadeList.push(obj);
      }
      this.getbuttonList(res.data);
      this.getkajaList(res.data);
    });
  }
  getbuttonList(param) {
    let data = param;
    for (var k = 0; k < param.length; k++) {
      let data1 = param[k];
      let obj: any = {};
      obj.shade = data1.shade;
      obj.gtot = data1.ftot * 14 + data1.htot * 8;
      this.buttonList.push(obj);
    }
  }
  calcTotal(param) {
    let data = param;
    this.totalList = param;
    let nan = function (no) {
        if (no == "" || no == null) {
          return 0;
        }
        if (isNaN(no)) {
          return 0;
        }
        return parseFloat(no + "");
      },
      fs_tot = 0,
      hs_tot = 0,
      f36_tot = 0,
      f38_tot = 0,
      f40_tot = 0,
      f42_tot = 0,
      f44_tot = 0,
      f46_tot = 0,
      tot_pcs = 0;
    for (let i = 0; i < this.totalList.length; i++) {
      const li = this.totalList[i];
      fs_tot +=
        nan(li["f36"]) +
        nan(li["f38"]) +
        nan(li["f40"]) +
        nan(li["f42"]) +
        nan(li["f44"]) +
        nan(li["f46"]);
      // hs_tot += nan(li['h36'])+ nan(li['h38'])+ nan(li['h40'])+ nan(li['h42'])+ nan(li['h44'])+ nan(li['h46']);
      f36_tot += nan(li["f36"]);
      f38_tot += nan(li["f38"]);
      f40_tot += nan(li["f40"]);
      f42_tot += nan(li["f42"]);
      f44_tot += nan(li["f44"]);
      f46_tot += nan(li["f46"]);
      tot_pcs += nan(li["ftot"]);
    }
    this.wodata.fs_total = fs_tot;
    //  this.wodata.hs_total = hs_tot;
    this.wodata.f36_tot = f36_tot;
    this.wodata.f38_tot = f38_tot;
    this.wodata.f40_tot = f40_tot;
    this.wodata.f42_tot = f42_tot;
    this.wodata.f44_tot = f44_tot;
    this.wodata.f46_tot = f46_tot;
    this.wodata.tot_pcs = tot_pcs;
  }
  getMatchList(param) {
    let params = {
      wo_id: param.wo_id,
      width: param.width,
    };
    this.woservice.getMatchList(params).then((res: any) => {
      this.designList2 = res.data;
      this.data = res.data;
      let temp = res.data;

      let parts1 = [];
      let parts2 = [];
      let parts3 = [];
      parts1.push(temp[0].mat1_part);
      parts2.push(temp[0].mat2_part);
      parts3.push(temp[0].mat3_part);

      let params = {
        parts1: parts1,
        parts2: parts2,
        parts3: parts3,
        width: this.width,
      };
      this.getTrims(params);
    });
  }

  getTrims(params) {
    this.woservice.getTrims(params).then((res: any) => {
      let temp = res;

      let obj: any = {};
      for (var k = 0; k < this.designList2.length; k++) {
        let data = this.designList2[k];
        obj.design_no = data.mat1_des_no;
        obj.color = data.mat1_color;
        obj.parts = data.mat1_part;
        this.trimsList.push(Object.assign({}, obj));
        obj.design_no = data.mat2_des_no;
        obj.color = data.mat2_color;
        obj.parts = data.mat2_part;
        this.trimsList.push(Object.assign({}, obj));
        obj.design_no = data.mat3_des_no;
        obj.color = data.mat3_color;
        obj.parts = data.mat3_part;
        this.trimsList.push(Object.assign({}, obj));
      }
      for (var j = 0; j < this.trimsList.length; j = j + 3) {
        let data1 = this.trimsList[j];
        this.trimsList[j].mtr = temp.data1.mtr;
        this.trimsList[j + 1].mtr = temp.data2.mtr;
        this.trimsList[j + 2].mtr = temp.data3.mtr;
      }
      // this.trimsList = res.data;
    });
  }
  getTotal() {
    this.des_total = 0;
    for (var i = 0; i < this.designList1.length; i++) {
      let design = this.designList1[i];
      this.des_total += design.mtr;
    }
  }
  getsizeList(param, data) {
    let shade = param.width;
    this.datalist = data;
    this.tot_pcs = param.tot_pcs;
    if (shade == 58) {
      for (var i = 0; i < data.length; i++) {
        let data1 = data[i];
        let data2 = data1.mat1_part;
        let data3 = data2.split(",");
        this.p1_val = data3;
        this.p1_total = 0;
        // this.getmat1List(this.p1_val, this.trimsList);
        //             for (var j = 0; j < data3.length; j++) {
        //                  this.p1_name = data3[j]
        //                 //  let params={
        //                 //      width:shade,
        //                 //      mat1_part:this.p1_name
        //                 //  }
        //         //         this.woservice
        //         //        .getMatch1part(params)
        //         //        .then((res: any) => {
        //         //            let p1_data = res.data;
        //         //            this.p1_val = (Math.round(this.tot_pcs/p1_data.qty))*p1_data.mtr;
        //         //            this.p1_total += this.p1_val;

        //         // });
        //  //       alert(this.p1_total);
        //             }
      }
    } else {
    }
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
        mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/woprint.ts